import { Analytics, EcommerceEvent, TrackProperties } from "./types";
import ReactPixel from "react-facebook-pixel";

enum AVAILABLE_EVENTS {
  AddToWishlist = "AddToWishlist",
  InitiateCheckout = "InitiateCheckout",
  Purchase = "Purchase",
}

function PixelAnalytics(): Analytics {
  return {
    group: () => {},
    register: () => {},
    identify: () => {},
    screen: () => {
      ReactPixel.pageView();
    },
    ecommerceEvent: (event: EcommerceEvent) => {
      /**
       * Track Purchase event when Order Complete
       * Track InitiateCheckout when user visit Checkout Page
       */
      switch (event.event) {
        case "Checkout Started":
          ReactPixel.track(AVAILABLE_EVENTS.InitiateCheckout);
          break;
        case "Order Completed":
          ReactPixel.track(AVAILABLE_EVENTS.Purchase, {
            currency: event.currency,
            value: event.revenue,
            content_ids: [event.id],
          });
          break;
      }
    },
    event: (eventName: string, properties: TrackProperties = {}) => {
      if ((Object as any).values(AVAILABLE_EVENTS).includes(eventName)) {
        ReactPixel.track(eventName, properties);
      } else {
        ReactPixel.trackCustom(eventName, properties);
      }
    },
  };
}

export class PixelSourceProvider {
  static CURRENT_TRACKING_ID: string = "";
  initialize(client: PixelClient): Analytics {
    if (PixelSourceProvider.CURRENT_TRACKING_ID !== client.pixelTrackingId) {
      ReactPixel.init(client.pixelTrackingId);
      PixelSourceProvider.CURRENT_TRACKING_ID = client.pixelTrackingId;
    }

    return PixelAnalytics();
  }
}

interface PixelTrackingOptions {
  pixelTrackingId: string;
}

export interface PixelClient extends PixelTrackingOptions {
  provider: "pixel";
}

export function makePixelClient(trackingId: string): PixelClient {
  return {
    provider: "pixel",
    pixelTrackingId: trackingId,
  };
}
